module.exports = __webpack_public_path__ + "static/media/Control_1_Thermocycler.0322ba7b.svg";